import { API_PORTAL_URL } from "@/lib/config";
import { IHomePageData } from "./homeModel";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";

export const getAllActiveSettings = createAsyncThunk(
  "Setting/FindAllActiveSetting",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Setting/FindAllActiveSetting`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHomePageData = async (): Promise<IHomePageData | null> => {
  try {
    const response = await fetch(`${API_PORTAL_URL}/Website/GetHomePageData`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      // Using Next.js cache options for server component
      next: { revalidate: 30 }, // Cache for 30 seconds
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch home page data: ${response.statusText}`);
    }

    const result = await response.json();
    return result?.Data || null;
  } catch (error) {
    console.error("Error Fetching Home Page Data (Server):", error);
    return null;
  }
};

export async function fetchCMSData(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/CMS/FindAllCMSURL`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ CMSURL: URL }),
      next: { revalidate: 1 },
    });
    if (!res.ok) {
      throw new Error(`Failed to fetch CMS data: ${res.statusText}`);
    }
    const json = await res.json();
    return json.Data ?? [];
  } catch (error) {
    console.error("Error Fetching CMS Data (Server):", error);
    return [];
  }
}
